/* eslint-disable import/prefer-default-export */
import { ADD_COUNTRY_CODE, getAction } from './type.actions';

export const setCountryAction = (data) => getAction(ADD_COUNTRY_CODE, data);
